<template>
  <div class="main__content">
    <div class="table__header_bar">
      <div>
        <InputSearch isFilter @detectSearchValue="searchTableHandler" />
      </div>
      <div class="btn-wrapper">
        <Button
          isControl
          iconName="star"
          @click.native="createReport"
        >
          {{ $t('sections.certification_agency_change_star_category') }}
        </Button>
        <div class="tooltip-wrapper" v-if="isExistsCategorisationInCurPeriod">
          <Tooltip
            :text="$t('tooltip.request_is_send_in_cur_reriod')"
            position="top"
            :is-dynamic="true"
          >
            <div class="tooltip-content" />
          </Tooltip>
        </div>
      </div>
    </div>
    <Table
      v-if="getTableOfCategorizationsHotelCA.table"
      :content="getTableOfCategorizationsHotelCA.table.items"
      @tableHandler="tableHandler"
    />
    <v-skeleton-loader v-else type="table" />
  </div>
</template>

<script>
import Table from '@/elements/Table';
import { mapGetters } from 'vuex';
import InputSearch from '@/elements/InputSearch';
export default {
  components: {
    InputSearch,
    Table,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'getTableOfCategorizationsHotelCA',
      'isHotelRequestTableExistsDraft',
      'getCurrentPage',
      'isExistsCategorisationInCurPeriod',
    ]),
  },
  created() {
    this.$store.dispatch('getTableOfCategorizationsHotelCA');
  },
  methods: {
    createReport() {
      this.$router.push({
        name: 'certification_agency_hotel_categorization-create',
        params: {
          activity: 'create',
        },
      });
    },

    tableHandler() {
      this.$store.dispatch('getTableOfCategorizationsHotelCA');
    },

    searchTableHandler(val) {
      this.$store.commit('SET_TABLE_SORT_DATA', { search: val });
      this.$store.dispatch('getTableOfCategorizationsHotelCA');
    },
  },
};
</script>

<style lang="sass" scoped>
.table__header_bar.input-search__form
  @include xs
    width: 300px
.btn-wrapper
  position: relative
.tooltip-wrapper, .tooltip-content
  position: absolute
  width: 100%
  height: 100%
  left: 0
  top: 0
</style>
